/**
 * Tooltip copy for deployed drone slots in battle UI.
 * @param {object} drone
 * @param {{ disruptorDeployed?: boolean, playerOwned?: boolean }} [options]
 */
export function buildDeployedDroneTooltipText(drone, { disruptorDeployed = false, playerOwned = false } = {}) {
  if (!drone || typeof drone !== 'object') {
    throw new Error('buildDeployedDroneTooltipText: drone is required');
  }
  const chargesPart =
    drone.charges !== undefined ? ` (${drone.charges} charges)` : ' (permanent effect)';
  const usedPart = playerOwned && drone.usedThisTurn ? ' - Used this turn' : '';
  const disruptorPart =
    playerOwned && disruptorDeployed ? ' - Inactive (Disruptor deployed)' : '';
  return `${drone.name} - ${drone.description || 'Drone'}${chargesPart}${usedPart}${disruptorPart}`;
}
